// extracted by mini-css-extract-plugin
export var button = "_di-0";
export var icon = "_di-1";